import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newBondtracking() {
    let bondtrackingDetails = {
      requisition_id: $(".requisition_id").val(),
      cargo_id: $(".cargo_id").val(),
      truck_id: $(".truck_id").val(),
      bond_id: $(".bond_id").val(),
      Ro: $(".Ro").val(),
      l_reporting: $(".l_reporting").val(),
      ml_collection: $(".ml_collection").val(),
      coe: $(".coe").val()
    };
    $(".creatingBondtracking").hide();
    $(".creatingBondtrackingLoader").show();
    baseurl.post(rt.newBondtracking, bondtrackingDetails).then(res => {
      $(".creatingBondtracking").show();
      $(".creatingBondtrackingLoader").hide();

      //checking for response codes
      if (res.data.code === 200) {
        //success codes
        suc.bondtrackingCreateSuccess();
        router.push("/managerequisitions");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //requisition with bond exits
        ers.BondtrackingExists();
        router.push("/managerequisitions");
      } else if (res.data.code === 404) {
        //error on iserting data
        ers.errorCreatingBondtracking();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadBondtrackings({ commit }) {
    baseurl.get(rt.loadBondtrackings).then(res => {
      $(".bondtrackingsLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success codes
        commit("STORE_BONDTRACKINGS", res.data.bondtrackings);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingBondtracking();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  viewBondtracking({ commit }, bondtrackingId) {
    commit("STORE_BONDTRACKING_UPDATE", bondtrackingId);
    router.push("/updatebondtracking");
  },

  updateBondtracking({ commit }) {
    let bondtrackingDetails = {
      id: $(".id").val(),
      requisition_id: $(".requisition_id").val(),
      cargo_id: $(".cargo_id").val(),
      truck_id: $(".truck_id").val(),
      bond_id: $(".bond_id").val(),
      Ro: $(".Ro").val(),
      l_reporting: $(".l_reporting").val(),
      ml_collection: $(".ml_collection").val(),
      coe: $(".coe").val()
    };
    $(".updatingBondtracking").hide();
    $(".updatingBondtrackingLoader").show();
    baseurl.post(rt.updateBondtracking, bondtrackingDetails).then(res => {
      $(".updatingBondtracking").show();
      $(".updatingBondtrackingLoader").hide();

      //checking response from backend api

      if (res.data.code === 200) {
        //success code
        commit("STORE_BONDTRACKINGS", res.data.bondtrackings);
        suc.bondtrackingUpdateSuccess();
        setTimeout(() => {
          router.push("/managebondtrackings");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating
        ers.errorUpdatingBondtracking();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/bondtrackings/actions.js